module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_stretchlab-407a35497cdd3e06742224b41c99168e.svg";